module.exports = __webpack_public_path__ + "static/media/jupyter.16880c22.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/jupyter.png
// module id = 1497
// module chunks = 0